export const productName = 'INDUSTRIAL INSTRUMENTATION TEACHER READY';
export const productShortName = 'Industrial Instrumentation Teacher Ready';
export const productImage = 'https://cdn.magicpatterns.com/uploads/uDX8TjnLEJWwM25SU3mH4M/MOCKUP_4.26.46_p._m..png';

export const checkoutUrl = 'https://industrial-instrumentation-teacher-ready.impultienda.ar/checkout';

export const price = 'USD 27.00';
export const priceBefore = 'USD 80.00';

export const totalVolumes = 9;
export const totalBonuses = 5;
export const bonusTotalValue = 'USD 70.00';

export const included = [
  'Volume 1 — Fundamentals of Industrial Instrumentation',
  'Volume 2 — Industrial Measurement Principles & Instrument Performance',
  'Volume 3 — Sensors, Transducers & Industrial Signals',
  'Volume 4 — Temperature, Pressure, Level & Flow Measurement',
  'Volume 5 — Industrial Control Systems & Control Loops',
  'Volume 6 — Control Valves, Actuators & Final Control Elements',
  'Volume 7 — PLC, SCADA & Industrial Automation Fundamentals',
  'Volume 8 — Calibration, Maintenance, Troubleshooting & Instrument Safety',
  'Volume 9 — Teaching Industrial Instrumentation',
  'Bonus 1 — 150 Classroom Activities & Challenges',
  'Bonus 2 — Industrial Instrumentation Teacher Assessment Kit',
  'Bonus 3 — 100 Case Studies & Problem-Solving Scenarios',
  'Bonus 4 — Industrial Instrumentation Teacher Dictionary: 200 Essential Concepts',
  'Bonus 5 — 100 Questions Students Ask About Industrial Instrumentation',
  '7-day money-back guarantee',
  'Instant access',
];

export const systemNegatives = [
  "It's not outdated theory copied from old textbooks.",
  "It's not a collection of disconnected activities.",
  "It's not material you'll need to completely rewrite.",
];

export const closingLines = [
  'No more sleepless nights searching for ways to explain complex instrumentation concepts',
  "No more rushed lessons with materials that don't work",
  "No more disconnected students who don't see instrumentation's relevance",
  'No more weekends spent building lesson plans from scratch',
  "No more awkward silences when students ask technical questions you weren't ready for",
];
